module.exports = __webpack_public_path__ + "img/b4.e021967a.png";